module.exports = __webpack_public_path__ + "img/search.7498177b.svg";